import { IconX } from '@tabler/icons-react';
import _debounce from 'lodash/debounce';
import React, { useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { imageUploadApi, postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { ensureHttpPrefix } from '../../../utils/url.utils';
import { accessCheck } from '../../../utils/accessCheck';
import { accessKeys } from '../../../statics/accessKeys';

const CreateLinkModal = ({ callback }) => {
    const [show, setShow] = useState(false);
    const [customBackResp, setCustomBackResp] = useState(null);
    const [isBulkUpload, setIsBulkUpload] = useState(false);
    const [file, setFile] = useState(null);
    const imageUploadInputRef = useRef(null);
    const handleClose = () => {
        setCustomBackResp(null);
        setIsBulkUpload(false);
        setFile(null);
        setShow(false)
    };
    const handleShow = () => setShow(true);

    const handleImageChange = (e) => {
        setFile(e.target.files[0]);
    }

    async function create() {
        loadingShow();
        let postData = {
            "link": ensureHttpPrefix(document.getElementById("link").value?.trim()),
        }
        if (document.getElementById("name").value?.trim()) {
            postData.name = document.getElementById("name").value?.trim();
        } if (document.getElementById("custom-back-half").value?.trim()) {
            postData.linkCode = document.getElementById("custom-back-half").value?.trim();
        }
        let resp = await postApi(postData, urlApi.createLink);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            if (callback) {
                callback();
            }
            handleClose();
        } else {
            toast.error(resp?.message);
        }
    }

    const checkCustomBackHalf = async (e) => {
        let postData = {
            "linkCode": e.target.value?.trim(),
        }
        if (e.target.value?.length >= 3) {
            let resp = await postApi(postData, urlApi.checkCustomBackHalf);
            setCustomBackResp(resp);
        } else if (e.target.value?.length == 0) {
            setCustomBackResp(null);
        }
    }

    async function bulkUpload() {
        loadingShow();
        let formData = new FormData();
        formData.append('linkList', file);
        let resp = await imageUploadApi(formData, urlApi.uploadBulkLinkCsv);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            if (callback) {
                callback();
            }
            handleClose();
        } else {
            toast.error(resp?.message);
        }
    }


    return (
        <>
            <button className='primary-btn float-end' onClick={handleShow}>Create Link</button>
            <Modal show={show} onHide={handleClose} size='lg' backdrop='static'>
                <Modal.Body className='rounded-xl p-0'>
                    <div className="flex justify-between items-center pt-3 px-4">
                        <p className="text-md font-semibold mb-0">Create Link</p>
                        <button onClick={handleClose}> <IconX /></button>
                    </div>
                    <hr className='my-2' />
                    <div className='px-5 py-2'>
                        <div className="flex items-center justify-between">
                            <p className="mb-0 text-sm"></p>
                            {accessCheck(accessKeys?.uploadBulkLink) && (isBulkUpload ? <button className='primary-outline-btn' onClick={() => setIsBulkUpload(false)}>Create Single Link</button> : <button className='primary-outline-btn' onClick={() => setIsBulkUpload(true)}>Upload Bulk</button>)}
                        </div>
                        {isBulkUpload ?
                            <div className='text-center'>
                                <input type="file" name="" id="" className="hidden" onChange={handleImageChange} ref={imageUploadInputRef} accept='.csv' />
                                <button onClick={() => imageUploadInputRef.current.click()} className='border-2 border-primary p-2 mb-3 rounded-lg'>
                                    <img src={file ? (process.env.PUBLIC_URL + "/images/csv.png") : (process.env.PUBLIC_URL + "/images/add-file.png")} className='cursor-pointer mx-auto h-20 rounded-lg object-cover' alt="" />
                                </button>
                                {file && <p className='text-sm font-medium mb-4'>{file.name}</p>}
                                <p className="text-md">
                                    1. Choose a CSV file (Under 50Mb) with the following format:
                                    <br />
                                    <code>
                                        link,name
                                    </code> <br />
                                    <a href={process.env.PUBLIC_URL + "/files/advy-bulk-link-sample.csv"} download={process.env.PUBLIC_URL + "/files/advy-bulk-link-sample.csv"} >Download Sample CSV</a>
                                    <br />
                                    2. Upload the file and wait for the short links to be generated. <span className='text-red-800'>(2-5 minutes)</span>
                                    <br />
                                    3. Share the generated short links with your audience.
                                </p>
                            </div>
                            : <div>
                                <div className='mb-3'>
                                    <label htmlFor="link" className='text-sm font-semibold mb-1'>Destination</label>
                                    <input type='text' id='link' className='w-full px-3 py-2 rounded-md border-2 text-sm' placeholder='Enter your long URL here...' />
                                </div>
                                <div className='mb-4'>
                                    <label htmlFor="" className='text-sm font-semibold mb-1'>Title (Optional)</label>
                                    <input type='text' id='name' className='w-full px-3 py-2 rounded-md border-2 text-sm' placeholder='Enter link title...' />
                                </div>

                                <p className='text-[20px] font-medium'>Short Link</p>

                                <div className="flex flex-wrap md:flex-nowrap">
                                    <div className='mb-3 w-full md:w-[50%] px-2'>
                                        <label htmlFor="" className='text-sm font-semibold mb-1'>Domain</label>
                                        <select className='px-3 py-2 rounded-md border-2 text-sm w-full'>
                                            <option value="https://short.ly/" selected disabled>advy.me</option>
                                        </select>
                                    </div>
                                    <div className='mb-3 w-full md:w-[50%] px-2'>
                                        <label htmlFor="" className='text-sm font-semibold mb-1'>Custom back-half (optional)</label>
                                        <input type='text' id='custom-back-half' className='w-full px-3 py-2 rounded-md border-2 text-sm' placeholder='Minimum 3 Character' onChange={_debounce((e) => checkCustomBackHalf(e), 300)} />
                                        <p className="mb-0 text-xs text-gray-500">
                                            *Minimum 3 characters, including alphanumeric characters and special characters (only '-' , '_').
                                        </p>
                                        {
                                            customBackResp &&
                                            <div className={`text-xs ps-1 ${customBackResp?.responseCode == 200 ? "text-green-700" : 'text-red-700'}`}>{customBackResp?.message}</div>
                                        }
                                    </div>
                                </div>

                                {/* <p className='text-[20px] font-medium'>Ways To Share</p>
                                <div className="flex justify-between">
                                    <p className="mb-0 text-lg font-bold">QR Code</p>
                                    <ToggleBtn state={isQrSelected} onClickFunction={() => setIsQrSelected(prev => !prev)} />
                                </div>
                                <p className='text-xs text-[#526281]'>Generate a QR Code to share anywhere people can see it</p> */}
                            </div>}

                    </div>
                    <hr className='my-3' />
                    <div className='flex justify-between gap-3 px-5 py-2'>
                        <button className='modal-cancel-btn' onClick={handleClose}>Cancel</button>
                        {isBulkUpload ? <button className='primary-btn' onClick={() => bulkUpload()}>Upload CSV</button> : <button className='primary-btn' onClick={() => create()}>Create Link</button>}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CreateLinkModal